import { render, staticRenderFns } from "./carOwnerAppraise.vue?vue&type=template&id=5d40a946&scoped=true&"
import script from "./carOwnerAppraise.vue?vue&type=script&lang=js&"
export * from "./carOwnerAppraise.vue?vue&type=script&lang=js&"
import style0 from "./carOwnerAppraise.vue?vue&type=style&index=0&id=5d40a946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40a946",
  null
  
)

export default component.exports